import React, { useState, useEffect } from 'react';
import axios from "axios";
import useInfiniteScroll from "../helpers/useInfinite";
import {VIMEO_TOKEN} from "../helpers/constants";
import parse from 'html-react-parser';
import '../css/video.css';
import Alert from 'react-bootstrap/Alert';
import LazyLoad from 'react-lazy-load';

const Vimeo = (props) => {


    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [error, setError] = useState('');
    const [isLoaded, setIsLoaded] = useState(false);
    const [isFetching, setIsFetching] = useInfiniteScroll(moreData);

    const loadData = () => {
        // let url = "https://api.vimeo.com/me/videos";
        let url = `https://api.vimeo.com/tags/DisplayPWA/videos?page=${page}`;
        axios.get(url,{
            headers: {
                'Authorization': 'Bearer ' + VIMEO_TOKEN
            }
        }).then(res => {
            if(res.data.data!=null){
                setData(res.data.data);
                setPage(page + 1)
            }

            setIsLoaded(true);
        }).catch((error) => {
            setError(error.message);
            setIsLoaded(true);
        });
    }
    function moreData() {
        // let url = `https://api.vimeo.com/me/videos?page=${page}`;
        let url = `https://api.vimeo.com/tags/DisplayPWA/videos?page=${page}`;
        axios.get(url,{
            headers: {
                'Authorization': 'Bearer ' + VIMEO_TOKEN
            }
        }).then(res => {
            if(res.data.data!=null){

                if(res.data.data.length > 0){
                    setData([...data, ...res.data.data]);
                    setPage(page + 1)
                }
                setIsFetching(false)
            }
        }).catch((error) => {
            setError(error.message);
        });
    }

    useEffect(() => {
        loadData()
    }, [])

    const viewFormat = (count) => {
        return new Intl.NumberFormat().format(count) + ' views';
    }

    const dateFormat = (date) =>{

        var options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
        var today  = new Date(date);

        return today.toLocaleDateString("en-US", options);
    }

    return (
        <div className="video-wrap">
            {data.length === 0 && error==='' && isLoaded == false && <p className="text-center">Loading...</p>}
            {data.length === 0 && error!=='' && <Alert className="mt-3" variant="warning">{error}</Alert>}
            <ul className="video-list">
                {data.map((video, key) => (
                
                <li className="single-video" key={key}>
                    <LazyLoad>
                        <div>
                        <div className="video">
                            {video.isPlay == null && <img 
                                // className={}
                                onClick={() => { 
                                    video.isPlay=1;
                                    setData([...data])
                                }}
                                src={video.pictures.base_link} 
                                alt={video.name} 
                                title={video.name} />}
                            {video.isPlay === 1 && parse(video.embed.html)}
                            {/* <div style="padding:56.25% 0 0 0;position:relative;"><iframe src={video.player_embed_url + "?h=8f88230f7c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"} frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title={video.name}></iframe></div><script src="https://player.vimeo.com/api/player.js"></script> */}
                        </div>
                        <div className="video-info">
                            <img src={video.uploader.pictures.base_link} alt="djmir" />
                            <div className="video-desc">
                                <h3 className="video-title">{video.name}</h3>
                                <p className="video-meta"><span className="views">{viewFormat(video.stats.plays)}</span> - <span className="publish-date">{dateFormat(video.release_time)}</span></p>
                            </div>
                        </div>
                        </div>
                    </LazyLoad>
                </li>
                ))}
            </ul>
        </div>
    )
}

export default Vimeo;